import { css } from '@emotion/react';
import IconInfoCircleOutline from '~icons/ci/info-circle-outline';
import { su, theme } from '@arc/frontend/ui-theme';
import { HubTooltip } from './HubTooltip';
const styles = {
  container: gray => /*#__PURE__*/css(su.roundedFull, {
    color: gray ? theme.colors.text.hint : theme.colors.lightBlue,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    border: 'none',
    '&:hover': {
      border: 'none',
      color: gray ? theme.colors.text.faint : theme.colors.palettes.primary.main
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:container;")
};
export function InfoCircle(props) {
  const {
    calloutText,
    size,
    tooltipProps,
    gray,
    ...buttonProps
  } = props;
  const sizeStyle = /*#__PURE__*/css({
    width: size ?? 20,
    height: size ?? 20
  }, process.env.NODE_ENV === "production" ? "" : ";label:sizeStyle;");
  return <HubTooltip {...tooltipProps} title={calloutText}>
			<button type="button" data-cy="info-circle" css={[styles.container(gray), sizeStyle, process.env.NODE_ENV === "production" ? "" : ";label:InfoCircle;"]} {...buttonProps}>
				<IconInfoCircleOutline css={sizeStyle} />
			</button>
		</HubTooltip>;
}